import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { UserPolicyEvalDto } from 'src/shared/services/api.service';
import { PolicySetKey } from 'src/shared/constants';
import { LocalStorageService } from 'src/shared/services/local-storage.service';

@Directive({
  selector: '[componentRequiresAnyPolicy]',
  standalone: false,
})
export class ComponentRequiresAnyPolicyDirective {
  private policies: (keyof UserPolicyEvalDto)[] = [];

  constructor(
    private readonly localStorageService: LocalStorageService,
    private readonly templateRef: TemplateRef<any>,
    private readonly viewContainerRef: ViewContainerRef,
  ) {}

  @Input() set componentRequiresAnyPolicy(policies: (keyof UserPolicyEvalDto)[] | keyof UserPolicyEvalDto) {
    this.policies = Array.isArray(policies) ? policies : [policies];
    const policySet = JSON.parse(this.localStorageService.get(PolicySetKey) ?? '{}') as UserPolicyEvalDto;
    this.viewContainerRef.clear();

    const allowed = this.policies.some((policyName) => policySet?.[policyName] === true);
    if (allowed) {
      this.viewContainerRef.createEmbeddedView(this.templateRef);
    }
  }
}
